module.exports = __webpack_public_path__ + "static/media/4.fe1cc37c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/brest/4.JPG
// module id = 218
// module chunks = 0